import React from 'react';
import getData from './getData';

/**
 *  Creates ListingCollection Schema component
 *
 */
function ListingCollection(_ref) {
  let {
    inventory,
    schemaTemplate = {},
    srpContent = {},
    schemaType,
    baseUrl,
    searchLocation,
    schemaUrl,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "listingsCollectionSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(inventory, schemaTemplate, srpContent, schemaType, baseUrl, searchLocation, schemaUrl))}`
    }
  }, rest));
}
export default ListingCollection;